<template>
    <div>
        <van-nav-bar
                left-arrow
                @click-left="toHome"
        >
            <template #title>
                <div @click="titleMapLoc">
                    {{title}}
                    <van-icon name="location" size="16" color="#27B1F9"/>
                </div>
            </template>
            <bv-icon slot="right" icon-class="chart" @click="toBuilding"/>
        </van-nav-bar>
        <van-tabs v-model="active" @change="onTabChange" swipeable>
            <van-tab title="销售情况" data-value="salesData">
                <van-swipe v-if="logos" :autoplay="3000" @change="swipeChange"
                           style="text-align: center;width: 100%;height: 210px">
                    <van-swipe-item v-for="(image, index) in logos" :key="index">
                        <van-image fit="cover" height="100%" width="100%" :src="imageImg(image)"/>
                    </van-swipe-item>
                    <div class="van-indicator-custom" slot="indicator">
                        {{ current + 1 }} / {{ logos.length }}
                    </div>
                </van-swipe>
                <van-cell title="查看销控表" is-link @click="toBuilding">
                    <bv-icon slot="icon" icon-class="chart"/>
                </van-cell>
                <div v-if="priceShows.length > 0">
                    <bv-block title="价格备案情况"/>
                    <van-row>
                        <div @click="toBuilding">
                            <bv-sales
                                    v-for="(priceShow, index) in priceShows"
                                    theme="other"
                                    :title="priceShow.houseShow"
                                    :key="index"
                                    :commonFormat="false"
                                    :specList="priceShow.housePrices"
                            />
                        </div>
                    </van-row>
                </div>
                <div class="seprator" v-if="residence.length > 0"/>
                <div v-if="residence.length > 0">
                    <bv-block title="住宅销售备案情况(单位:套)" :fold="true" @on-fold="onResidenceFold"/>
                    <div v-if="residenceFold">
                        <div class="wrapper-residence" @click="toBuilding">
                            <div class="header">
                                总套数：{{residenceCollects.totalNum}}
                            </div>
                            <div class="saled">
                                已<br/>网<br/>签<br/>备<br/>案
                            </div>
                            <div class="saled-sum">
                                合&nbsp;&nbsp;计
                            </div>
                            <div class="saled-signed">
                                已签订
                            </div>
                            <div class="saled-signing">
                                网签备案中
                            </div>
                            <div class="saled-sum-value">
                                {{residenceCollects.sellNum}}
                            </div>
                            <div class="saled-signed-value">
                                {{residenceCollects.signedNum}}
                            </div>
                            <div class="saled-signing-value">
                                {{residenceCollects.signingNum}}
                            </div>
                            <div class="nosale">
                                自留/非卖
                            </div>
                            <div class="nosale-value">
                                {{residenceCollects.nosaleNum}}
                            </div>
                            <div class="saling">
                                未<br/>网<br/>签<br/>备<br/>案
                            </div>
                            <div class="saling-sum">
                                合计
                            </div>
                            <div class="saling-signed">
                                查封
                            </div>
                            <div class="saling-signing">
                                抵押
                            </div>
                            <div class="saling-sum-value">
                                {{residenceCollects.nosaledNum}}
                            </div>
                            <div class="saling-signed-value">
                                {{residenceCollects.closeNum}}
                            </div>
                            <div class="saling-signing-value">
                                {{residenceCollects.mortgageNum}}
                            </div>
                            <div class="close">
                                关闭
                            </div>
                            <div class="close-value">
                                {{residenceCollects.frozen}}
                            </div>
                        </div>
                        <van-row>
                            <div v-if="residence">
                                <bv-sales
                                        v-for="(sales, index) in residence"
                                        :title="sales.houseShow"
                                        :key="index"
                                        :commonFormat="true"
                                        :totalNum="sales.totalNum"
                                        :nosaledNum="sales.nosaledNum"
                                        :sellNum="sales.sellNum"
                                        :nosaleNum="sales.nosaleNum"
                                        :nosaleReason="sales.nosaleReason"
                                        :rowLength="maxResidenceLength"
                                        @on-house-show="saleClick"
                                />
                            </div>
                        </van-row>
                    </div>
                </div>
                <div class="seprator" v-if="business.length > 0"/>
                <div v-if="business.length > 0">
                    <bv-block title="商业销售备案情况(单位:套)" :fold="true" @on-fold="onBusinessFold"/>
                    <div v-if="businessFold">
                        <div class="wrapper-business" @click="toBuilding">
                            <div class="header">
                                总套数：{{businessCollects.totalNum}}
                            </div>
                            <div class="saled">
                                已<br/>网<br/>签<br/>备<br/>案
                            </div>
                            <div class="saled-sum">
                                合&nbsp;&nbsp;计
                            </div>
                            <div class="saled-signed">
                                已签订
                            </div>
                            <div class="saled-signing">
                                网签备案中
                            </div>
                            <div class="saled-sum-value">
                                {{businessCollects.sellNum}}
                            </div>
                            <div class="saled-signed-value">
                                {{businessCollects.signedNum}}
                            </div>
                            <div class="saled-signing-value">
                                {{businessCollects.signingNum}}
                            </div>
                            <div class="nosale">
                                自留/非卖
                            </div>
                            <div class="nosale-value">
                                {{businessCollects.nosaleNum}}
                            </div>
                            <div class="saling">
                                未<br/>网<br/>签<br/>备<br/>案
                            </div>
                            <div class="saling-sum">
                                合计
                            </div>
                            <div class="saling-signed">
                                查封
                            </div>
                            <div class="saling-signing">
                                抵押
                            </div>
                            <div class="saling-sum-value">
                                {{businessCollects.nosaledNum}}
                            </div>
                            <div class="saling-signed-value">
                                {{businessCollects.mortgageNum}}
                            </div>
                            <div class="saling-signing-value">
                                {{businessCollects.closeNum}}
                            </div>
                            <div class="close">
                                关闭
                            </div>
                            <div class="close-value">
                                {{businessCollects.frozen}}
                            </div>
                        </div>
                        <van-row>
                            <div v-if="business">
                                <bv-sales
                                        v-for="(sales, index) in business"
                                        theme="green"
                                        :title="sales.houseShow"
                                        :key="index"
                                        :commonFormat="true"
                                        :totalNum="sales.totalNum"
                                        :nosaledNum="sales.nosaledNum"
                                        :sellNum="sales.sellNum"
                                        :nosaleNum="sales.nosaleNum"
                                        :nosaleReason="sales.nosaleReason"
                                        :rowLength="maxBusinessLength"
                                        @on-house-show="saleClick"
                                />
                            </div>
                        </van-row>
                    </div>
                </div>
                <div class="seprator" v-if="mating.length > 0"/>
                <div v-if="mating.length>0">
                    <bv-block title="配套销售备案情况(单位:套)" :fold="true" @on-fold="onMatingFold"/>
                    <div v-if="matingFold">
                        <div class="wrapper-mating" @click="toBuilding">
                            <div class="header">
                                总套数：{{matingCollects.totalNum}}
                            </div>
                            <div class="saled">
                                已<br/>网<br/>签<br/>备<br/>案
                            </div>
                            <div class="saled-sum">
                                合&nbsp;&nbsp;计
                            </div>
                            <div class="saled-signed">
                                已签订
                            </div>
                            <div class="saled-signing">
                                网签备案中
                            </div>
                            <div class="saled-sum-value">
                                {{matingCollects.sellNum}}
                            </div>
                            <div class="saled-signed-value">
                                {{matingCollects.signedNum}}
                            </div>
                            <div class="saled-signing-value">
                                {{matingCollects.signingNum}}
                            </div>
                            <div class="nosale">
                                自留/非卖
                            </div>
                            <div class="nosale-value">
                                {{matingCollects.nosaleNum}}
                            </div>
                            <div class="saling">
                                未<br/>网<br/>签<br/>备<br/>案
                            </div>
                            <div class="saling-sum">
                                合计
                            </div>
                            <div class="saling-signed">
                                查封
                            </div>
                            <div class="saling-signing">
                                抵押
                            </div>
                            <div class="saling-sum-value">
                                {{matingCollects.nosaledNum}}
                            </div>
                            <div class="saling-signed-value">
                                {{matingCollects.closeNum}}
                            </div>
                            <div class="saling-signing-value">
                                {{matingCollects.mortgageNum}}
                            </div>
                            <div class="close">
                                关闭
                            </div>
                            <div class="close-value">
                                {{matingCollects.frozen}}
                            </div>
                        </div>
                        <van-row>
                            <div v-if="mating">
                                <bv-sales
                                        v-for="(sales, index) in mating"
                                        theme="yellow"
                                        :title="sales.houseShow"
                                        :key="index"
                                        :commonFormat="true"
                                        :totalNum="sales.totalNum"
                                        :nosaledNum="sales.nosaledNum"
                                        :sellNum="sales.sellNum"
                                        :nosaleNum="sales.nosaleNum"
                                        :nosaleReason="sales.nosaleReason"
                                        :rowLength="maxMatingLength"
                                        @on-house-show="saleClick"
                                />
                            </div>
                        </van-row>
                    </div>
                </div>
            </van-tab>
            <van-tab title="户型图" data-value="houseHold">
                <div v-for="(docFiles, index) in listDocFiles" :key="'houseHold_docFiles_' + index">
                    <van-panel v-if="docFiles.imageList && docFiles.imageList.length>0" :title="docFiles.docName">
                        <div class="flex" @click="showImage(docFiles)">
                            <van-row>
                                <van-col span="8" style="height: 100px;padding: 1px 1px 1px 1px;"
                                         v-for="(docFile, index) in docFiles.imageList"
                                         :key="'houseHold_docFile_' + index">
                                    <img v-lazy="docFile.thumbUrl" height="100%" width="100%"/>
                                </van-col>
                            </van-row>
                        </div>
                    </van-panel>
                </div>
            </van-tab>
            <van-tab title="项目相册" data-value="regionImage">
                <div v-for="(docFiles, index) in listDocFiles" :key="'regionImage_docFiles_' + index">
                    <van-panel v-if="docFiles.imageList && docFiles.imageList.length>0" :title="docFiles.docName">
                        <div class="flex" @click="showImage(docFiles)">
                            <van-row>
                                <van-col span="8" style="height: 100px;padding: 1px 1px 1px 1px;"
                                         v-for="(docFile, index) in docFiles.imageList"
                                         :key="'regionImage_docFile_' + index">
                                    <img v-lazy="docFile.thumbUrl" height="100%" width="100%"/>
                                </van-col>
                            </van-row>
                        </div>
                    </van-panel>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import {Swipe, SwipeItem, Cell, Row, Col, Tab, Tabs, Image, Panel, ImagePreview, NavBar, Toast} from 'vant'
    import Block from '../components/Block'
    import Sales from '../components/Sales'
    import {regionSales, regionDocs, fetchRegionById} from '@/api/houseResource/region'
    import wx from "weixin-js-sdk";
    import {jsApiSignature} from '@/api/wx'

    export default {
        name: 'Sales',
        components: {
            VanNavBar: NavBar,
            VanSwipe: Swipe,
            VanSwipeItem: SwipeItem,
            VanCell: Cell,
            BvBlock: Block,
            BvSales: Sales,
            VanRow: Row,
            VanCol: Col,
            VanTab: Tab,
            VanTabs: Tabs,
            VanImage: Image,
            VanPanel: Panel,
        },
        data() {
            return {
                title: "",
                address: "",
                centerPositionX: "",
                centerPositionY: "",
                active: 0,
                current: 0,
                logos: [],
                residence: [],
                mating: [],
                business: [],
                priceShows: [],
                listDocFiles: [],
                residenceCollects: {},
                matingCollects: {},
                businessCollects: {},
                residenceFold: true,
                matingFold: true,
                businessFold: true,
                maxResidenceLength: 1,
                maxMatingLength: 1,
                maxBusinessLength: 1,
                signRes: {
                    appId: '',
                    nonceStr: '',
                    signature: '',
                    timestamp: ''
                },
            }
        },
        created() {
            this.fetchRegionById();
        },
        computed: {},
        methods: {
            fetchRegionById() {
                let regionId = this.$route.query.regionId;
                fetchRegionById(regionId).then(res => {
                    let region = res.data;
                    this.title = region.regionName;
                    this.address = region.address;
                    this.centerPositionY = region.y;
                    this.centerPositionX = region.x;
                })
            },
            titleMapLoc() {
                var _this = this;
                // url是外网可访问地址（域名）
                let url = location.href.split('#')[0];
                //传url给后台,从后台获取appId/timestamp/nonceStr/signature
                jsApiSignature({url: url}).then(res => {
                    let resV = res.data;
                    _this.signRes.appId = resV.appId;
                    _this.signRes.nonceStr = resV.nonceStr;
                    _this.signRes.signature = resV.signature;
                    _this.signRes.timestamp = resV.timestamp.toString();
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: _this.signRes.appId, // 必填，公众号的唯一标识
                        timestamp: _this.signRes.timestamp, // 必填，生成签名的时间戳
                        nonceStr: _this.signRes.nonceStr, // 必填，生成签名的随机串
                        signature: _this.signRes.signature,// 必填，签名
                        jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
                    });
                }).catch(() => {
                    Toast.fail("签名接口异常，请联系管理员！")
                })
                // 通过ready接口处理config成功验证
                // console.log("x==" + _this.$route.query.x + "===y" + _this.$route.query.y + "===name" + _this.title + "===address" + _this.address)
                // console.info(_this.address)
                wx.ready(function () {
                    wx.openLocation({
                        latitude: parseFloat(_this.centerPositionY),
                        longitude: parseFloat(_this.centerPositionX),
                        scale: 14,
                        name: _this.title,
                        address: _this.address,
                        success: function (openLoc) {
                            console.log("打开内置地图成功后的回调" + openLoc)
                        },
                        fail: function () {
                            Toast.fail("打开位置异常，请联系管理员！")
                        },
                    })
                })
                // 通过error接口处理config失败验证
                wx.error(function () {
                    Toast.fail("验证签名接口异常，请联系管理员！")
                });
            },
            //全屏加载提示
            showLoading() {
                Toast.loading({
                    // 持续展示 toast
                    duration: 0,
                    mask: true,
                    message: '加载中...'
                });
            },
            toHome() {
                let from = this.$route.query.from;
                this.$router.push(from);
            },
            swipeChange(index) {
                this.current = index
            },
            toBuilding() {
                this.$router.push({
                    path: '/houseResource/buildingView',
                    query: {
                        regionId: this.$route.query.regionId,
                        regionName: this.$route.query.regionName,
                        from: this.$route.query.from
                    }
                });
            },
            salesData() {
                this.showLoading();
                let regionId = this.$route.query.regionId;
                regionSales(regionId).then(res => {
                    this.logos = res.data.logos;
                    this.residence = res.data.residence;
                    this.mating = res.data.mating;
                    this.business = res.data.business;
                    this.priceShows = res.data.priceShows;
                    this.residenceCollects = res.data.residenceCollects;
                    this.matingCollects = res.data.matingCollects;
                    this.businessCollects = res.data.businessCollects;
                    //判断每种类型的最大bv-sales最大行数
                    this.residence.forEach(sale => {
                        //初始为1，统计行
                        let length = 1;
                        if (sale.nosaledNum && sale.nosaledNum > 0) {
                            length++
                        }
                        if (sale.sellNum && sale.sellNum > 0) {
                            length++
                        }
                        if (sale.nosaleNum && sale.nosaleNum > 0) {
                            length++
                        }
                        if (this.maxResidenceLength < length) {
                            this.maxResidenceLength = length
                        }
                    });
                    this.mating.forEach(sale => {
                        let length = 1;
                        if (sale.nosaledNum && sale.nosaledNum > 0) {
                            length++
                        }
                        if (sale.sellNum && sale.sellNum > 0) {
                            length++
                        }
                        if (sale.nosaleNum && sale.nosaleNum > 0) {
                            length++
                        }
                        if (this.maxMatingLength < length) {
                            this.maxMatingLength = length
                        }
                    });
                    this.business.forEach(sale => {
                        let length = 1;
                        if (sale.nosaledNum && sale.nosaledNum > 0) {
                            length++
                        }
                        if (sale.sellNum && sale.sellNum > 0) {
                            length++
                        }
                        if (sale.nosaleNum && sale.nosaleNum > 0) {
                            length++
                        }
                        if (this.maxBusinessLength < length) {
                            this.maxBusinessLength = length
                        }
                    });
                    Toast.clear();
                });
            },
            imageImg(imagePath) {
                return imagePath != null ? imagePath : require('@/assets/nothing.png');
            },
            regionDocs(type) {
                this.showLoading();
                let regionId = this.$route.query.regionId;
                regionDocs(regionId, type).then(res => {
                    this.listDocFiles = res.data;
                    Toast.clear();
                });
            },
            onTabChange(index) {
                if (index === 0) { // 销售情况
                    this.salesData();
                } else if (index === 1) { // 户型图
                    this.regionDocs('houseHold');
                } else { // 项目相册
                    this.regionDocs('regionImage'); // 项目相册
                }
            },
            showImage(docFiles) {
                let imageArray = [];
                if (docFiles && docFiles.imageList) {
                    for (let i = 0; i < docFiles.imageList.length; i++) {
                        imageArray.push(docFiles.imageList[i].viewUrl);
                    }
                    ImagePreview({
                        images: imageArray,
                        //页面退出时自动关闭
                        closeOnPopstate: true,
                        //showIndicators: true
                    });
                }
            },
            onResidenceFold(isShow) {
                this.residenceFold = !isShow
            },
            onMatingFold(isShow) {
                this.matingFold = !isShow
            },
            onBusinessFold(isShow) {
                this.businessFold = !isShow
            },
            saleClick(houseShow) {
                this.$router.push({
                    path: '/houseResource/buildingView',
                    query: {
                        regionId: this.$route.query.regionId,
                        regionName: this.$route.query.regionName,
                        from: this.$route.query.from,
                        houseShow: houseShow
                    }
                });
            }
        },
        mounted() {
            this.active = 0;
            this.salesData();
        }
    }
</script>
<style lang="scss" scoped>
    .van-nav-bar__title {
        max-width: 80%;
    }

    .wrapper-residence {
        margin: 10px;
        border: 1px #D2F0FE solid;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: 40px 40px 40px 40px 40px;
        /*grid-gap: 2px;*/
        grid-template-areas: "h h h h h h h h h h h h" "sd sdm sdm sdm sdmv sdmv si sim sim sim simv simv" "sd sdd sdd sdd sddv sddv si sid sid sid sidv sidv" "sd sdg sdg sdg sdgv sdgv si sig sig sig sigv sigv" "ns ns ns ns nsv nsv c c c c cv cv";

        > div {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px #D2F0FE solid;
            font-size: 14px;
        }

        .header {
            grid-area: h;
            background-color: #ABE4FF;
            font-size: 16px;
            font-weight: bold;
        }

        .saled {
            grid-area: sd;
            background-color: #E9F8FF;
            font-size: 16px;
            font-weight: bold;
        }

        .saled-sum {
            grid-area: sdm;
            background-color: #E9F8FF;
        }

        .saled-signed {
            grid-area: sdd;
            background-color: #E9F8FF;
        }

        .saled-signing {
            grid-area: sdg;
            background-color: #E9F8FF;
        }

        .saled-sum-value {
            grid-area: sdmv;
        }

        .saled-signed-value {
            grid-area: sddv;
        }

        .saled-signing-value {
            grid-area: sdgv;
        }

        .nosale {
            grid-area: ns;
            background-color: #E9F8FF;
        }

        .nosale-value {
            grid-area: nsv;
        }

        .saling {
            grid-area: si;
            background-color: #E9F8FF;
            font-size: 16px;
            font-weight: bold;
        }

        .saling-sum {
            grid-area: sim;
            background-color: #E9F8FF;
        }

        .saling-signed {
            grid-area: sid;
            background-color: #E9F8FF;
        }

        .saling-signing {
            grid-area: sig;
            background-color: #E9F8FF;
        }

        .saling-sum-value {
            grid-area: simv;
        }

        .saling-signed-value {
            grid-area: sidv;
        }

        .saling-signing-value {
            grid-area: sigv;
        }

        .close {
            grid-area: c;
            background-color: #E9F8FF;
        }

        .close-value {
            grid-area: cv;
        }
    }

    .wrapper-mating {
        margin: 10px;
        border: 1px #FFEFD8 solid;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: 40px 40px 40px 40px 40px;
        /*grid-gap: 2px;*/
        grid-template-areas: "h h h h h h h h h h h h" "sd sdm sdm sdm sdmv sdmv si sim sim sim simv simv" "sd sdd sdd sdd sddv sddv si sid sid sid sidv sidv" "sd sdg sdg sdg sdgv sdgv si sig sig sig sigv sigv" "ns ns ns ns nsv nsv c c c c cv cv";

        > div {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px #FFEFD8 solid;
            font-size: 14px;
        }

        .header {
            grid-area: h;
            background-color: #FFDFB0;
            font-size: 16px;
            font-weight: bold;
        }

        .saled {
            grid-area: sd;
            background-color: #FEF5E6;
            font-size: 16px;
            font-weight: bold;
        }

        .saled-sum {
            grid-area: sdm;
            background-color: #FEF5E6;
        }

        .saled-signed {
            grid-area: sdd;
            background-color: #FEF5E6;
        }

        .saled-signing {
            grid-area: sdg;
            background-color: #FEF5E6;
        }

        .saled-sum-value {
            grid-area: sdmv;
        }

        .saled-signed-value {
            grid-area: sddv;
        }

        .saled-signing-value {
            grid-area: sdgv;
        }

        .nosale {
            grid-area: ns;
            background-color: #FEF5E6;
        }

        .nosale-value {
            grid-area: nsv;
        }

        .saling {
            grid-area: si;
            background-color: #FEF5E6;
            font-size: 16px;
            font-weight: bold;
        }

        .saling-sum {
            grid-area: sim;
            background-color: #FEF5E6;
        }

        .saling-signed {
            grid-area: sid;
            background-color: #FEF5E6;
        }

        .saling-signing {
            grid-area: sig;
            background-color: #FEF5E6;
        }

        .saling-sum-value {
            grid-area: simv;
        }

        .saling-signed-value {
            grid-area: sidv;
        }

        .saling-signing-value {
            grid-area: sigv;
        }

        .close {
            grid-area: c;
            background-color: #FEF5E6;
        }

        .close-value {
            grid-area: cv;
        }
    }

    .wrapper-business {
        margin: 10px;
        border: 1px #b0f8ff solid;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: 40px 40px 40px 40px 40px;
        /*grid-gap: 2px;*/
        grid-template-areas: "h h h h h h h h h h h h" "sd sdm sdm sdm sdmv sdmv si sim sim sim simv simv" "sd sdd sdd sdd sddv sddv si sid sid sid sidv sidv" "sd sdg sdg sdg sdgv sdgv si sig sig sig sigv sigv" "ns ns ns ns nsv nsv c c c c cv cv";

        > div {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px #b0f8ff solid;
            font-size: 14px;
        }

        .header {
            grid-area: h;
            background-color: #b0f8ff;
            font-size: 16px;
            font-weight: bold;
        }

        .saled {
            grid-area: sd;
            background-color: #e4fdff;
            font-size: 16px;
            font-weight: bold;
        }

        .saled-sum {
            grid-area: sdm;
            background-color: #e4fdff;
        }

        .saled-signed {
            grid-area: sdd;
            background-color: #e4fdff;
        }

        .saled-signing {
            grid-area: sdg;
            background-color: #e4fdff;
        }

        .saled-sum-value {
            grid-area: sdmv;
        }

        .saled-signed-value {
            grid-area: sddv;
        }

        .saled-signing-value {
            grid-area: sdgv;
        }

        .nosale {
            grid-area: ns;
            background-color: #e4fdff;
        }

        .nosale-value {
            grid-area: nsv;
        }

        .saling {
            grid-area: si;
            background-color: #e4fdff;
            font-size: 16px;
            font-weight: bold;
        }

        .saling-sum {
            grid-area: sim;
            background-color: #e4fdff;
        }

        .saling-signed {
            grid-area: sid;
            background-color: #e4fdff;
        }

        .saling-signing {
            grid-area: sig;
            background-color: #e4fdff;
        }

        .saling-sum-value {
            grid-area: simv;
        }

        .saling-signed-value {
            grid-area: sidv;
        }

        .saling-signing-value {
            grid-area: sigv;
        }

        .close {
            grid-area: c;
            background-color: #e4fdff;
        }

        .close-value {
            grid-area: cv;
        }
    }
</style>
